import React from "react";
import { toast } from "sonner";
import { Copy } from "lucide-react";

export function ProfileCodeChip({ code, className = "" }) {
  const copy = () => {
    navigator.clipboard.writeText(code);
    toast.success("Profile code copied", { description: code });
  };
  return (
    <button
      data-testid="copy-profile-code-btn"
      onClick={copy}
      className={`group inline-flex items-center gap-1.5 rounded-full border border-[#E5E0D8] bg-[#F4F0EA] px-3 py-1 font-mono text-xs font-semibold text-[#0D5C3A] transition-colors hover:bg-[#0D5C3A] hover:text-white ${className}`}
      title="Copy profile code"
    >
      {code}
      <Copy className="h-3.5 w-3.5 opacity-70 group-hover:opacity-100" />
    </button>
  );
}
